<template>
  <button-dialog-container
    :btn-icon="icon"
    :size="getSize"
    :only-icon="true"
    :no-tool-tip="noToolTip"
    :title-tool-tip="titleToolTip"
    :width-dialog="600"
    @ok-pushed="returnText"
  >
    <v-container class="pa-0">
      <v-row>
        <v-col
          class="pt-4"
          cols="5"
        >
          <v-radio-group
            v-model="radio"
            :z-index="1"
            mandatory
          >
            <v-row
              v-for="(choice, index) in radioChoices"
              :key="index"
              dense
            >
              <v-radio
                :label="choice.label"
                :value="choice.value"
              />
            </v-row>
          </v-radio-group>
        </v-col>
        <v-col
          class="mt-4"
          cols="7"
        >
          <template v-if="radio == 'cal-date'">
            <v-select
              v-model="valueDate"
              :items="itemsDate"
              :label="$t('creation.tools.dialog.calendar.format')"
              item-text="label"
              item-value="value"
              dense
            />
          </template>
          <template v-if="radio == 'cal-hour'">
            <v-select
              v-model="valueHour"
              :items="itemsHour"
              :label="$t('creation.tools.dialog.calendar.format')"
              item-text="label"
              item-value="value"
              dense
            />
          </template>
          <template v-if="radio == 'cal-count'">
            <v-menu
              v-model="menuDate"
              :close-on-content-click="false"
              :nudge-right="50"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  prepend-icon="mdi-calendar"
                  readonly
                  dense
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="date"
                :z-index="6"
                @input="menuDate = false"
              />
            </v-menu>
            <v-switch
              v-model="noText"
              class="mt-1"
              :label="$t('creation.tools.dialog.calendar.only-number')"
              dense
            />
          </template>
        </v-col>
      </v-row>
    </v-container>
  </button-dialog-container>
</template>

<script>
// Components
import buttonDialogContainer from "../Common/ButtonDialogContainer";

// Libs
const moment = require("moment");

export default {
  components: {
    buttonDialogContainer,
  },
  props: {
    icon: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    toolName: {
      type: String,
      default: "",
    },
    titleToolTip: {
      type: String,
      default: "",
    },
    noToolTip: {
      type: Boolean,
      default: true,
    },
    getSize: {
      type: Number,
      default: 25,
    },
  },
  data() {
    return {
      date: moment().format("YYYY-MM-DD"),
      itemsDate: [
        {
          label: moment().locale(this.$i18n.locale).format("dddd D MMMM"),
          value: "dddd D MMMM",
        },
        {
          label: moment().locale(this.$i18n.locale).format("dddd D"),
          value: "dddd D",
        },
        {
          label: moment().locale(this.$i18n.locale).format("D MMMM"),
          value: "D MMMM",
        },
        {
          label: moment().locale(this.$i18n.locale).format("dddd D MMMM YYYY"),
          value: "dddd D MMMM YYYY",
        },
        {
          label: moment().locale(this.$i18n.locale).format("L"),
          value: "L",
        },
        {
          label: moment().locale(this.$i18n.locale).format("DD.MM.YYYY"),
          value: "DD.MM.YYYY",
        },
        {
          label: moment().locale(this.$i18n.locale).format("dddd"),
          value: "dddd",
        },
        {
          label: moment().locale(this.$i18n.locale).format("D"),
          value: "D",
        },
        {
          label: moment().locale(this.$i18n.locale).format("MMMM"),
          value: "MMMM",
        },
        {
          label: moment().locale(this.$i18n.locale).format("YYYY"),
          value: "YYYY",
        },
      ],
      itemsHour: [
        {
          label: moment().locale(this.$i18n.locale).format("LT"),
          value: "LT",
        },
        {
          label: moment().locale(this.$i18n.locale).format("HH[h]mm"),
          value: "HH[h]mm",
        },
        {
          label: moment().locale(this.$i18n.locale).format("HH"),
          value: "HH",
        },
        {
          label: moment().locale(this.$i18n.locale).format("mm"),
          value: "mm",
        },
      ],
      valueDate: "",
      valueHour: "",
      menuDate: false,
      noText: false,
      radio: null,
      radioChoices: [
        {
          label: this.$t("creation.tools.dialog.calendar.date"),
          value: "cal-date",
        },
        {
          label: this.$t("creation.tools.dialog.calendar.hour"),
          value: "cal-hour",
        },
        {
          label: this.$t("creation.tools.dialog.calendar.weeknum"),
          value: "cal-weeknum",
        },
        {
          label: this.$t("creation.tools.dialog.calendar.count"),
          value: "cal-count",
        },
      ],
    };
  },
  methods: {
    returnText() {
      if (this.radio.length > 0) {
        if (this.toolName) this.$emit("toolSelectedFromDialog", this.toolName);

        this.$emit("calendarSelect", this.radio, this.valueDate, this.valueHour, this.date, this.noText);
      }
    },
  },
};
</script>

<style></style>
